import { render, staticRenderFns } from "./selectApprovers.vue?vue&type=template&id=0ab7fbf6&scoped=true&"
import script from "./selectApprovers.vue?vue&type=script&lang=js&"
export * from "./selectApprovers.vue?vue&type=script&lang=js&"
import style0 from "./selectApprovers.vue?vue&type=style&index=0&id=0ab7fbf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7fbf6",
  null
  
)

export default component.exports